import { useFormContext } from "react-hook-form";
import { FieldSetInputProps } from "components/voc";
import styled, { css } from "styled-components";
import IconSelect from "assets/images/icon_select.png";

const BottomSheetTextWrapper = styled.span`
  position: relative;
  padding: 1.4rem 5rem 1.4rem 1.6rem;
  border: 1px solid #a8b2ba;
  border-radius: 0.8rem;
  font-family: "Pretendard", sans-serif;
  color: #000;
  text-align: left;

  &::after {
    position: absolute;
    top: 50%;
    right: 1.5rem;
    width: 1.8rem;
    height: 1.8rem;
    margin-top: -0.9rem;
    background: url(${IconSelect}) no-repeat center;
    background-size: 1.8rem;
    content: "";
  }

  .btn_bottomsheet.-data {
    color: #000;
  }
`;

const TextStyled = styled.input<{ bottomSheetText?: boolean }>`
  ${(props) =>
    !props.bottomSheetText &&
    css`
      display: block;
      width: 100%;
      padding: 1.4rem 1.6rem;
      border: 1px solid #a8b2ba;
      border-radius: 0.8rem;
      font-family: "Pretendard", sans-serif;
    `}

  ::-moz-placeholder {
    color: #c9c9c9;
  }

  ::placeholder {
    color: #c9c9c9;
  }
`;

type FieldTextProps = FieldSetInputProps;

const FieldText = ({ name, onClick, ...props }: FieldTextProps) => {
  const { register } = useFormContext();
  return (
    <>
      {(props.className?.includes("btn_bottomsheet") && (
        <BottomSheetTextWrapper onClick={onClick}>
          <TextStyled {...register(name!)} {...props} bottomSheetText={true} />
        </BottomSheetTextWrapper>
      )) || <TextStyled {...register(name!)} {...props} bottomSheetText={false} />}
    </>
  );
};

export default FieldText;
